module.exports = __webpack_public_path__ + "img/maps.7541f2f8.png";